import { CardComponents } from './CardComponents';

const json = [
    {
        "title": "ENOCA, APRIL 2023 - PRESENT - JAVA SAP CX DEVELOPER",
        "subTitle":"CARREFOURSA HYBRIS B2C E-COMMERCE PROJECT – TURKEY",
        "description": "- 5+ minor/major projects development Custom page and component developments\n - Custom product structure and order-process architecture\n - 3rd party application integration\n - SOLR Configurations and Development\n - Backoffice and Cockpit development\n - Bug fixes on pages, order etc."
    }
    ,
    {
        "title": "KODLINE",
        "description":"- REST API development using Laravel\n - 3rd party application integration" 
       
    }
];


export const Experiences = () => {
    return (CardComponents(json))
};
